
import { supabase } from '@/integrations/supabase/client';

/**
 * Reset a user's daily game counter to allow them to play again
 * @param userId The user ID to reset
 * @returns Promise resolving to true if successful
 */
export const resetUserGameCounter = async (userId: string): Promise<boolean> => {
  try {
    console.log('Resetting game counter for user:', userId);
    
    const { error } = await supabase
      .from('customer_profiles')
      .update({ games_played_today: 0 })
      .eq('id', userId);
      
    if (error) {
      console.error('Error resetting game counter:', error);
      return false;
    }
    
    console.log('Game counter reset successfully');
    return true;
  } catch (error) {
    console.error('Error in resetUserGameCounter:', error);
    return false;
  }
};
